<template>
	<div class="slots">
		<div class="slots__alert alert alert-danger" v-if="error.show">
			{{ error.text }}
		</div>
		<div class="slots__head">
			<div class="slots__search">
				<input
						type="text"
						class="field-input__input"
						autocomplete="false"
						placeholder="Поиск по названию игры"
						v-model="search"
						readonly="readonly"
						onfocus="this.removeAttribute('readonly');"
						:class="search ? 'fill' : ''"
				>
				<button @click="reset()" v-if="search && search.trim().length >= 2" class="btn field-input__clear">
					<span>&times;</span>
				</button>
			</div>
			<div class="slots__provider-btn btn" @click="showProviders = true">
				<img v-if="currentProvider" :src="currentProvider.icon" alt="" class="btn__icon">
				{{ currentProviderName ? currentProviderName : 'Провайдеры' }}
				<svg class="slots__provider-btn-icon">
					<use href="#svg-icon-chevron"></use>
				</svg>
			</div>
		</div>

		<div class="slots__items" v-if="!error.show" ref="slots">
			<component class="slots__item"
				v-for="(game, i) in games"
				:is="isMobile ? 'div' : 'router-link'"
				:key="game.id"
				:to="{name: 'slotsGame', params: { gameId: game.id }}"
				@click="isMobile ? getGame(game.id) : null"
			>
				<div class="slots__badges">
					<div v-if="game.vpn_required" class="badge badge-danger slots__badge rounded-sm">VPN</div>
					<div class="slots__badge"
					:class="{
						warn: game.wager_multiply > 1,
						success: game.wager_multiply == 1,
						danger: game.wager_multiply == 0,
					}">
						WAGER X{{game.wager_multiply}}
					</div>
				</div>
				<img class="slots__item-img" :src="game.image" :alt="game.name">
			</component>
		</div>
		<div class="slots__message" v-show="games.length == 0 && !loading"  :style="{backgroundImage: 'url(/assets/boomx/images/slots-bg.jpg)'}">
			По вашему запросу игр не найдено
		</div>

		<teleport to="body">
			<Modal :openState="showProviders" :data="{title: 'Выберите провайдера'}" @close="() => showProviders = false" class="providers__modal">
				<Providers
					:providers="providers"
					:key="showProviders"
				   	@setActive="toggleProvider"
				   	@setAll="refreshResults"
				   	:active="selectedProvider"
				/>
			</Modal>
		</teleport>


        <div class="loader" v-show="loading"></div>

	</div>
</template>

<script>
	import Modal from "../../components/blocks/Modal.vue";
	import {nextTick} from "vue";
	import Providers from "../../components/blocks/Providers.vue";

    export default {
		components: {
			Providers,
			Modal
		},

        data() {
            return {
                search: null,
                error: {
                    show: false,
                    message: ''
                },
                games: [],
                providers: [],
                selectedProvider: null,
                page: 1,
                totalPages: 0,
                delay: null,
                gameId: null,
                isMobile: false,
				showProviders: false,
				loading: false,
				observer: null,
				observerItem: null
            }
        },
        computed: {
            category_id: function () {
                return this.$root.$slotegrator[this.$route.name];
            },

			currentProviderName() {
				return this.providers.find(item => item.provider_id === this.selectedProvider)?.provider_name
			},

			currentProvider() {
				return this.providers.find(item => item.provider_id === this.selectedProvider)
			}
        },

		watch: {
			search() {
				if(this.search && this.search.trim().length >= 2) {
					clearTimeout(this.delay);

					this.delay = setTimeout(() => {
						this.getGames(true);
					}, 750);
				}
			},

			games: {
				async handler() {
					await nextTick()
					if (this.$refs.slots) {
						this.observerItem = this.$refs.slots.lastElementChild;
					}
				}
			},

			observerItem(newItem, oldItem) {
				if (oldItem) {
					this.observer.unobserve(oldItem);
				}
				this.observer.observe(newItem)
				if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 100) {
					window.scrollBy(0, -100)
				}
			}
		},

        beforeMount() {
            this.getProviders();
        },
        mounted() {
            this.loading = true;
            this.isMobile = this.$isMobile();

			this.observer = new IntersectionObserver(this.observerCallback, {
				rootMargin: "300px",
				threshold: 0.5
			});
            this.getGames();
        },
        methods: {
            applyFilter() {
                this.getGames(true);
            },
            toggleProvider(id) {
                if(this.selectedProvider === id) {
                    return this.refreshResults();
                }
                
                this.selectedProvider = id;

                this.applyFilter();
                this.showProviders = false;
            },
            refreshResults() {
                this.selectedProvider = null;
				this.showProviders = false;
                this.getGames(true);
            },
			observerCallback (entries) {
				if (!entries[0] || !entries[0].isIntersecting || this.loading || this.page >= this.totalPages) {
					return
				}
				this.page += 1;
				this.getGames();
            },
            getProviders() {
				this.$root.axios.post('/api/slots/providers', {
                    category_id: this.category_id
                })
                .then(res => {
                    this.providers = res.data;
                }).catch(error => {
 
                    this.error = {
                        show: true,
                        text: this.$root.graphql.axiosGetError(error)
                    };

					this.$root.isLoading = false;
                })
            },
            reset() {
                this.search = null;
                this.getGames(true);
            },
            getGames(refresh = false) {
                this.loading = true;

                if(refresh) {
                    this.page = 1;
                    this.totalPages = 0;
                    this.games = [];
                }

                this.$root.axios.post('/api/slots/games', {
                    page: this.page,
                    category_id: this.category_id,
                    search: this.search,
                    provider: this.selectedProvider
                })
                .then(res => {
                    const data = res.data;

					this.$root.isLoading = false;
                    this.loading = false;
                    this.totalPages = data.meta.last_page;
                    this.page = data.meta.current_page;
                    this.games = this.games.concat(data.data);
                }).catch(error => {
                    this.error = {
                        show: true,
                        text: this.$root.graphql.axiosGetError(error)
                    };
					this.$root.isLoading = false;
                    this.loading = false;
                })
            },
            getGame(gameId) {
                this.loading = true;
                
                this.$root.axios.post('/api/slots/init', {
                    game_id: gameId,
                    mobile: true
                }).then(res => {
                    const data = res.data;
                    window.location.href = data?.url?.launch_options?.game_url ?? data?.url;
                }).catch(error => {
                    this.error = {
                        show: true,
                        text: this.$root.graphql.axiosGetError(error)
                    };

                    this.$root.isLoading = false;
                })
            }
        }
    }
</script>
